<template>
  <AboutBanner />
  <AboutContent />
</template>

<script lang="ts" type="text/tsx">
import AboutBanner from '@template/page/about/aboutBanner.vue';
import AboutContent from '@template/page/about/aboutContent.vue';

export default {
  name: 'about',
  components: {
    AboutBanner,
    AboutContent
  },
  mounted(): void {
    $Store.Page().checkPointCompany(true);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/about/';
</style>